import { CalendarDays, Clock3 } from 'lucide-react';
import { APP_TIME_ZONE, useServerClock } from '../../../hooks/useServerClock';
import { cn } from '../../../lib/cn';

const DATE = new Intl.DateTimeFormat('th-TH', { timeZone: APP_TIME_ZONE, weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
const TIME = new Intl.DateTimeFormat('en-GB', { timeZone: APP_TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
/** en-CA formats as YYYY-MM-DD — the machine-readable date in the app's zone, not UTC. */
const ISO_DATE = new Intl.DateTimeFormat('en-CA', { timeZone: APP_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit' });

function syncLabel(offsetMs: number | null): string {
  if (offsetMs === null) return 'ยังซิงก์กับเซิร์ฟเวอร์ไม่ได้ — แสดงเวลาของเครื่องนี้';
  const s = Math.abs(offsetMs) / 1000;
  const drift = s < 1 ? 'นาฬิกาเครื่องนี้ตรงกับเซิร์ฟเวอร์' : `นาฬิกาเครื่องนี้${offsetMs > 0 ? 'ช้า' : 'เร็ว'}กว่าเซิร์ฟเวอร์ ${s.toFixed(1)} วินาที (ปรับให้แล้ว)`;
  return `เวลาเซิร์ฟเวอร์ (${APP_TIME_ZONE}) · ${drift}`;
}

/** Today's date and time in one row, synced to the server clock — the reference for every forecast and "late" flag. */
export function ClockChip() {
  const { now, offsetMs } = useServerClock();
  const synced = offsetMs !== null;

  return (
    <div title={syncLabel(offsetMs)} className="hidden h-9 items-center gap-2.5 rounded-full border border-border bg-surface-sunken px-3.5 sm:flex">
      <span className="flex items-center gap-1.5 text-xs font-medium text-text-secondary">
        <CalendarDays size={14} className="text-primary" />
        <time dateTime={ISO_DATE.format(now)}>{DATE.format(now)}</time>
      </span>
      <span className="h-4 w-px bg-border-strong" aria-hidden />
      <span className="flex items-center gap-1.5">
        <Clock3 size={14} className="text-primary" />
        <time dateTime={now.toISOString()} className="num w-[4.6rem] font-mono text-sm font-semibold tracking-tight text-text-primary">
          {TIME.format(now)}
        </time>
        <span className={cn('h-1.5 w-1.5 rounded-full', synced ? 'bg-ok' : 'bg-warn')} aria-label={synced ? 'ซิงก์แล้ว' : 'ยังไม่ซิงก์'} />
      </span>
    </div>
  );
}
